import React from "react"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store from "./store"
import ReactDOM from "react-dom/client";

if (process.env.REACT_APP_NODE === "prod") {
  console.log = console.warn = console.error = () => { };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.REACT_APP_BASE_FOLDER}>
      <App />
    </BrowserRouter>
  </Provider>
)

serviceWorker.unregister()
